import { Typography, TextField, Stack } from "@mui/material";
import React, { useState } from "react";
import { useFiltersWithContext } from "../filter-context/useFiltersWithContext";
import { useTranslation } from "../../../hooks/useTranslation";

type TextFilterProps = {
  name: string;
  labelKey: string;
  labelVars?: Record<string, string>;
};

export const TextFilter = (props: TextFilterProps) => {
  const { name, labelKey, labelVars } = props;

  const { getFilterValue, setFilter, deleteFilter } = useFiltersWithContext();
  const { translate } = useTranslation();

  const [value, setValue] = useState<string>(
    getFilterValue(name, "contains")?.toString() ?? "",
  );

  const handleChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    const newValue = e.target.value;
    setValue(newValue);

    if (newValue.trim() !== "") {
      setFilter({
        field: name,
        value: newValue,
        labelInfo: {
          descriptionKey: labelKey,
          value: newValue,
        },
        operator: "contains",
      });
    } else {
      deleteFilter(name, "contains");
    }
  };

  return (
    <Stack direction={"row"} alignItems={"center"}>
      <Typography flex={1}>{translate(labelKey, labelVars)}</Typography>
      <TextField
        size="small"
        type="text"
        value={value}
        onChange={handleChange}
        sx={{ minWidth: 200 }}
      />
    </Stack>
  );
};
